export default __webpack_public_path__ + "static/media/enviroment_icon.8e6bc3b2.png";